<script setup lang="ts">
import type { Property } from '~/core/entities/property';

const props = withDefaults(
	defineProps<{
		ad?: Property['ad'];
		isLoading?: boolean;
		summary?: string;
		numberOfSkeletonGroups?: number;
		numberOfSkeletonLinesPerGroup?: number;
	}>(),
	{
		numberOfSkeletonGroups: 2,
		numberOfSkeletonLinesPerGroup: 6
	}
);

const description = computed<string>(() => {
	if (!props.ad) return '';

	const text = props.ad.description.trim();

	return /[.!?]$/.test(text) ? text : `${text}.`;
});
</script>

<template>
	<div v-if="isLoading" class="flex w-full flex-col items-start gap-8">
		<div
			v-for="group in numberOfSkeletonGroups"
			:key="`property-description-section-skeleton-${group}`"
			class="flex w-full flex-col items-start gap-3"
		>
			<Skeleton
				v-for="line in numberOfSkeletonLinesPerGroup"
				:key="`property-description-section-skeleton-${group}-${line}`"
				:is-active="true"
				class="h-4 w-full last:w-3/5"
				variant="white"
			/>
		</div>
	</div>

	<ExpandableContainer v-else>
		<span
			v-if="props.summary"
			class="font-sans text-xl font-medium leading-[150%]"
		>
			{{ props.summary }}
		</span>
		<p class="pt-5 first-letter:uppercase">
			{{ description }}
		</p>
	</ExpandableContainer>
</template>
